// extracted by mini-css-extract-plugin
export default {"wrapper":"QjQdp","main":"DfYFN","action":"kYVce","link":"EqM4I","skeleton":"WuOOK","block":"yRrbZ","error":"YFuvp","line":"ow0As"};